import send from '../../util/request';
// import { objectToLine } from '../../util/convert';

// 退货单列表
export const inventoryReturnOrders = (params = {}) => {
	return send({ url: '/ipp/inventory/return-orders', method: 'POST', data: params, options: { loading: true } });
};